"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ResetPasswordSceneTranslation = {
    fi: {
        ResetPasswordScene: {
            siteTitle: 'Vaihda salasana',
            title: 'Kirjoita uusi salasana',
            subTitle: 'Kirjoita uusi salasanasi ja paina tallenna',
            password: 'Salasana',
            button: 'Tallenna',
        },
    },
    en: {
        ResetPasswordScene: {
            siteTitle: 'Change password',
            title: 'Set new password',
            subTitle: 'Write new password and click save!',
            password: 'Password',
            button: 'Save',
        },
    },
};
exports.default = ResetPasswordSceneTranslation;
//# sourceMappingURL=ResetPasswordScene.translation.js.map